import { aawzDate } from '@utils/dates/aawz-date'

export const buildInitialState = () => ({
  filtros_opcoes: {
    cidade: [],
    estado: [],
    empresa: [],
    filial: [],
    segmento: [],
  },
  filtros: {
    cidade: [],
    estado: [],
    empresa: [],
    filial: [],
    segmento: [],
  },
  // Para partnership
  profissionais: {
    /**
     * nome: str
     * unidade: str
     * regiao: str
     * qtd_cotas: str
     * part_percent: str
     * part_real: str
     * equipe: str
     */
    data: [],
    lastUpdate: null,
    loading: false,
    metadata: {},
  },
  segmentos: {
    data: [],
    cores: {},
    lastUpdate: null,
    loading: false,
  },
  senioridade: {
    data: [],
    lastUpdate: null,
    loading: false,
  },
  // Para grafico donut
  qtdProfissionaisPoolSocietario: 6,
  faixaCorteQuadrantes: {
    data: {
      pl_limite: 60000000,
      pl_potenical_limite: 60000000 / 0.4,
    },
    lastUpdate: null,
    loading: false,
  },
  temDadosFinanceiro: {
    data: false,
    lastUpdate: null,
    loading: false,
  },
  hierarquiaEmpresas: {
    data: {},
    lastUpdate: null,
    loading: false,
  },
  empresas: {
    data: [],
    lastUpdate: null,
    loading: false,
  },
  planosCarreira: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  planoSelecionado: {
    loading: false,
    lastUpdate: null,
    data: {
      plano: {},
      dados_planos: [],
    },
  },
  dadosGerais: {
    loading: false,
    lastUpdate: null,
    data: {
      data_atualizacao: null,
      summary: {},
      captacao: {},
      concentracao: {},
      segmentacao: {},
    },
  },
  documentos: {
    loading: false,
    lastUpdate: null,
    data: {
      0: {
        data: [],
        loading: false,
        lastUpdate: null,
      },
    },
  },
  financeiroUnico: {
    data: {
      1: [],
      2: [],
    },
    hasZeroValue: false,
    loading: false,
    lastUpdate: null,
  },
  financeiroConversao: {
    data: {
      1: [],
      2: [],
    },
    hasZeroValue: false,
    loading: false,
    lastUpdate: null,
  },
  financeiroComissao: {
    loading: false,
    lastUpdate: null,
    hasZeroValue: false,
    data: {
      1: [],
      2: [],
    },
  },
  /**
   * Valores fixos por enquanto.
   */
  tiposProfissionais: {
    data: [
      {
        data_atualizacao: '14/09/2021 18:37:18',
        data_registro: '14/09/2021 18:37:18',
        id: 2,
        id_escritorio: 1,
        tipo_profissional: 'Gerente',
      },
      {
        data_atualizacao: '14/09/2021 18:37:18',
        data_registro: '14/09/2021 18:37:18',
        id: 1,
        id_escritorio: 1,
        tipo_profissional: 'AAI',
      },
    ],
    loading: false,
    lastUpdate: null,
  },
  parametrosRegioes: {
    loading: false,
    lastUpdate: null,
    data: [],
    opcoes: [],
  },
  /**
   * Usar as opcoes da rota de segmentacoes
   */
  parametrosSegmentos: {
    loading: false,
    lastUpdate: null,
    data: {}, // {id: participacao}
  },
  parametrosContratacoes: {
    loading: false,
    lastUpdate: null,
    data: {},
  },
  parametrosIncentivos: {
    loading: false,
    lastUpdate: null,
    data: {},
  },
  parametrosMetasEscritorio: {
    loading: false,
    lastUpdate: null,
    data: {},
  },
  parametrosMetasProfissionais: {
    loading: false,
    lastUpdate: null,
    data: {},
    lista: [],
  },
  projecaoAuC: {
    loading: false,
    lastUpdate: null,
    status: 200,
    message: '',
    data: {
      auc: {},
      current_dre: {},
      hiring_plan: {},
      projected_dre: {},
      valuation: {},
    },
  },
  historicoAuC: {
    loading: false,
    lastUpdate: null,
    data: {
      office: {},
      professional: {},
    },
  },
  historicoAuCProfissional: {
    loading: false,
    lastUpdate: null,
    data: {},
  },
  contratacoesEfetivadas: {
    loading: false,
    lastUpdate: null,
    data: [],
    clusters: {
      1: {},
      2: {},
    },
    sum: {
      1: {}, // AAI
      2: {}, // Gerente
    },
  },
  parametrosAdicionais: {
    loading: false,
    lastUpdate: null,
    data: {
      id: '',
      ano_inicio_analise: '',
      caixa_atual: '',
      custo_variavel_medio: '',
      custos_fixos_medios: '',
      data_atualizacao: '',
      data_referencia: '',
      data_registro: '',
      ebitda_12_meses: '',
      horizonte_analise_em_anos: '',
      lucro_12_meses: '',
      multiplo_rubrica_valuation: '',
      porcentagem_custo_fixo_pelareceita: '',
      receita_12_meses: '',
      roa_medio: '',
      rubrica_valuation: '',
    },
  },
  custosAdicionais: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  historicoPlanilhas: {
    loading: false,
    lastUpdate: null,
    data: [],
    dicLastByType: {},
  },
  externAgents: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  partnershipsProfessionals: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  partnershipsExternAgents: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  // Multiplos disponíveis para calculo do valuation
  multiplos: {
    loading: false,
    lastUpdate: null,
    data: ['EBITDA', 'Lucro Líquido', 'Receita Bruta'],
  },
  // Filiais fisicas do escritorio
  filiais: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  // Dados do plano de expansao para apresentar o projetado e o plano de expansao para AuC e Time.
  projecaoAucTeam: {
    loading: false,
    lastUpdate: null,
    data: {},
  },
  dataRoomFiles: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  dataRoomOptions: {
    loading: false,
    lastUpdate: null,
    data: [],
  },

  optionFilter: {
    auc: 3000000.0,
    active: true,
  },

  optionsRequiredFiles: {
    loading: false,
    lastUpdate: null,
    data: [],
  },

  dataRoomSelectedYear: aawzDate().year(),
})

export default buildInitialState()
